<div class="relative overflow-x-auto py-6 bg-black shadow-lg rounded-xl p-6 border border-gray-700">
  <!-- Page Title -->
  <h1 class="text-3xl font-bold text-yellow-400 pb-4 border-b border-gray-700">
    🏙️ City List
  </h1>

  <!-- Filter Component -->
  <div class="py-4">
    <app-cities-filter />
  </div>

  <!-- Create Button -->
  <div class="flex justify-end py-4">
    <a
      routerLink="/cities/create"
      class="bg-gradient-to-r from-yellow-500 to-yellow-700 hover:from-yellow-600 hover:to-yellow-800 text-white font-bold py-2 px-6 rounded-full shadow-md transition duration-300"
    >
      ➕ Add City
    </a>
  </div>

  <!-- //Table -->
  <table class="w-full text-sm text-left text-yellow-300 border border-gray-700 rounded-lg overflow-hidden">
    <thead class="text-md text-yellow-400 uppercase bg-gray-900">
      <tr>
        <th scope="col" class="px-6 py-4">ID</th>
        <th scope="col" class="px-6 py-4">City Name</th>
        <th scope="col" class="px-6 py-4">State Name</th>
        <th scope="col" class="px-6 py-4">Country Name</th>
        <th scope="col" class="px-6 py-4 text-center">Action</th>
      </tr>
    </thead>

    <tbody>
      <tr
        class="bg-gray-900 border-b border-gray-700 hover:bg-gray-800 transition duration-300"
        *ngFor="let city of cities"
      >
        <th scope="row" class="px-6 py-4 font-semibold text-yellow-300">
          {{ city.id }}
        </th>
        <td class="px-6 py-4">{{ city.name }}</td>
        <td class="px-6 py-4">{{ city.state.name }}</td>
        <td class="px-6 py-4">{{ city.country.name }}</td>
        <td class="px-6 py-4 text-center flex justify-center space-x-4">
          <a
            routerLink="/cities/{{ city.id }}/edit"
            class="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-full shadow-lg transform hover:scale-105 transition-all duration-300"
          >
            ✏️ Edit
          </a>
          <button
            (click)="deleteCity($event, city.id)"
            class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded-full shadow-lg transform hover:scale-105 transition-all duration-300"
          >
            🗑️ Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
